/**
 * Primary bottom-nav destinations. Keep labels short for six-item mobile bars.
 */
export type PrimaryNavItem = {
  to: string;
  label: string;
  /** When true, only the exact route matches. */
  end?: boolean;
};

export const PRIMARY_NAV_ITEMS: readonly PrimaryNavItem[] = [
  { to: '/', label: 'Library', end: true },
  { to: '/calculator', label: 'Blend' },
  { to: '/spin', label: 'Wheel' },
  { to: '/history', label: 'History' },
  { to: '/rituals', label: 'Rituals' },
  { to: '/settings', label: 'Settings' },
] as const;
